import { generateSelectListOptions, SelectListOption, selectListOptionWithValue } from "@shared/components/form-fields/select-list-option";
import { DatesUtil } from "@shared/utilities/dates/dates.util";

export enum TaskStatus {
  InProgress = 'In progress',
  Completed = 'Completed'
}

export type TaskTracking = 'upcoming' | 'now' | 'overdue';

export const taskTrackingOptions: SelectListOption[] = [
  { label: 'Overdue', value: 'overdue' },
  { label: 'Now', value: 'now' },
  { label: 'Upcoming', value: 'upcoming' },
];

export type TaskPriority = 'Low' | 'Medium' | 'High';


export const taskStatusOptions = generateSelectListOptions(Object.values(TaskStatus));

// TODO: need to review utils below / update to utils + pipes
export function priorityMessage(priority: string): TaskPriority | undefined {
  switch(priority) {
    case '!': return 'Low';
    case '!!': return 'Medium';
    case '!!!': return 'High';
    default: return;
  }
}
